/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { PayersApi } from '../api/payers.api';
import { switchMap, map } from 'rxjs/operators';
import { FamilLinkData, FamilyLink } from '../../../interfaces/patient-services/family-link';
import { PatientRegistrationData, PatientRegistration } from '../../../interfaces/patient-services/patient-registration';
import { FamilyLinkApi } from '../api/familyLink.api';

@Injectable()
export class FamilyLinkService extends FamilLinkData {

  constructor(private api: FamilyLinkApi) {
    super();
  }


  list(url: string): Observable<FamilyLink[]> {
    return this.api.list(url);
  }

  searchList(url: string): Observable<PatientRegistration[]> {
    return this.api.list(url);
  }

  getById(url:string): Observable<FamilyLink>{
      return this.api.getById(url);
  }

  create(url: string, data:FamilyLink[]): Observable<FamilyLink> {
    return this.api.add(url,data);
  }

  update(url: string, data:FamilyLink): Observable<FamilyLink> {
    return this.api.update(url,data);
  }

  

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
